<template>
	<div class="view discover-view has-footer viewheight">
		<HeaderBar @search="onSearch"
				   @clear="onClear" />
		<NavBar :fixedItemList="fixedNavItemList"
				:itemList="minorNavItemList"
				:selectedItemId="selectedNavItemId"
				:onItemClick="onNavItemClick"
				:type="0" />

		<van-swipe ref="vanSwipe"
				   @change="onSwipeChange"
				   :loop="false"
				   :show-indicators="false">
			<van-swipe-item v-for="item in mergedNavItemList"
							:key="item.id">
				<Index2 v-if="item.id === selectedNavItemId"
						:selectedNavItemId="selectedNavItemId"
						:viewedNewsId="viewedNewsId"
						:firstLoadedHandler="onFirstLoaded" />
			</van-swipe-item>
		</van-swipe>

	</div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import { getChannels, setChannels, removeUser } from '../../utils/storageUtil'
import { scrollToLeft } from '../../utils/globalUtil'
import apiUtil from '../../utils/apiUtil'
import apiConst from '../../consts/apiConst'
import HeaderBar from '../../components/HeaderBar'
import NavBar from '../../components/NavBar'
import Index2 from './Index2';
export default {
	name: 'discover',
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		HeaderBar,
		NavBar,
		Index2
	},
	data() {
		return {
			selectedNavItemId: 0,
			viewedNewsId: 0, // 刚刚看过详情的新闻id
			fixedNavItemList: [],
			minorNavItemList: [],
			mergedNavItemList: [],
			firstLoaded: false // 一旦首次加载过后，之后所有的切换swipe行为都要将viewedNewsId置为0


		}
	},
	created() {

		this.init()
	},

	methods: {

		/**
		 * 初始化导航条和用户登录状态
		 */
		async init() {
			const res = await apiUtil.post(apiConst.getDiscoverIndex, {})
			if (res) {
				const {
					category: { group_a, group_b },
					uid
				} = res

				if (this.mergedNavItemList.length === 0) {
					const fixedNavItemList = group_a.map(ele => {
						ele.isHardItem = true
						if (ele.cate_name === '关注') {
							ele.hasChildren = true
						}
						return ele
					});
					const temp = getChannels() || {};
					const favList = (temp && temp["0"]) ? temp["0"] : [];
					const minorNavItemList = favList.length > 0 ? favList : group_b;
					this.fixedNavItemList = fixedNavItemList;
					this.minorNavItemList = minorNavItemList
					this.mergedNavItemList = fixedNavItemList.concat(minorNavItemList);
					const { cate_id, newsId } = this.$route.query;
					this.viewedNewsId = newsId ? parseInt(newsId) : 0;
					if (!!cate_id) {
						this.selectedNavItemId = parseInt(cate_id)
						this.$refs.vanSwipe.swipeTo(this.findIndexByNavId(cate_id));
					} else {
						this.selectedNavItemId = group_a[0].id;
					}
				}
				if (!uid) {
					removeUser()
				}
			}
		},

		onFirstLoaded(){
			this.firstLoaded = true;
		},

		findIndexByNavId(id) {
			const index = this.mergedNavItemList.findIndex(ele => ele.id == id)
			return index
		},


		/**
		 * @param isDragDown 是否因下拉刷新导致的init
		 */
		// init(isDragDown = false) {
		// 	const cate_id = this.$route.query.cate_id
		// 	if (cate_id) {
		// 		if (isDragDown) {
		// 			this.firstLoaded = false
		// 			this.isNoContent = false
		// 			this.newsItemList = []
		// 			this.initOtherView(cate_id, 1)
		// 		} else {
		// 			this.initOtherView(cate_id, this.page, isDragDown)

		// 		}
		// 		this.selectedNavItem = parseInt(cate_id)
		// 		this.cate_id = parseInt(cate_id);
		// 	} else {
		// 		this.initIndexView(isDragDown)
		// 	}
		// },

		onSwipeChange(index) {
			let id;
			if (index >= this.fixedNavItemList.length) {
				id = this.minorNavItemList[index - this.fixedNavItemList.length].id
			} else {
				id = this.fixedNavItemList[index].id
			}
			this.selectedNavItemId = id;
			if(this.firstLoaded){
				this.viewedNewsId = 0;
			}
			let query = this.$route.query;
			this.$router.push({ query: Object.assign({}, query, {cate_id: id}) })
			this.navItemScrollToView(id)
		},

		navItemScrollToView(id){
			const navItem = this.$el.querySelector('#navItem_'+id);
			const wrapper = this.$el.querySelector('#navListNormal');

			if(navItem){
				
				scrollToLeft(wrapper, navItem.offsetLeft, 200)

			}
		},


		onNavItemClick(item, index) {
			// this.onSwipeChange(index)
			this.selectedNavItemId = item.id;
			if(this.firstLoaded){
				this.viewedNewsId = 0;
			}
			this.$refs.vanSwipe.swipeTo(index);
		},

		onTagClick(tag_id) {
			this.$router.push({ name: 'filtered', query: { tag_id } })
		},

		onSearch(str) {
			this.$router.push({
				name: 'search',
				query: {
					keyword: str,
					type: 1
				}
			})
			this.onClear()
		},

		onClear() {
			// this.isSearch = false
		},
		onRefresh() {
			this.init(true)
		}
	}
}
</script>
<style lang="stylus">
.discover-view {
	overflow: auto;
    height: 100%;
	/* padding-top: 176px; */
	.van-swipe {
		// height: 100%;
		// overflow-y: auto;
	}
}
</style>
